import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from '../models/modalConfig';
import { AngularModalService } from './modal.service';
import { CompanyPageDeleteAssessmentCredentialModalComponent } from 'src/app/pages/mission-control-page/company-page/company-page-delete-assessment-credential-modal/company-page-delete-assessment-credential-modal.component';

// Downgraded (see service.module.ajs.js) so the still-AngularJS
// company-page.component.js root controller (native port not due until
// build step 10) can open this native modal in place of its old
// `this.$uibModal.open({component: 'deleteAssessmentCredentialModal', ...})`
// call.
@Injectable({
  providedIn: 'root'
})
export class CompanyPageDeleteAssessmentCredentialModalService {

  deleteAssessmentCredentialModal!: BsModalRef;

  constructor(private bsModalService: BsModalService, private angularModalService: AngularModalService) { }

  show(initialState: {
    context: string;
    companyId: any;
    buId: any;
    testOwnerEmail: any;
    assessmentId: any;
    isDeleteCredential: boolean;
  }, onResult: (callbackObject: any) => void): void {
    const config = new ModalConfig();
    config.class = 'custom-modal-xl';
    config.ignoreBackdropClick = true;
    config.initialState = initialState;
    this.deleteAssessmentCredentialModal = this.bsModalService.show(CompanyPageDeleteAssessmentCredentialModalComponent, config);
    this.deleteAssessmentCredentialModal.content.onClose.subscribe((callbackObject: any) => {
      this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      onResult(callbackObject);
    });
  }
}
